import * as React from 'react';
import { mergeStyles } from '@cian/utils';

import * as styles from './styles.css';

const FADE_MILLISECONDS = 2500;

interface IPointerProps {
  type: 'finger' | 'arrow';
  visible?: boolean;
  isAnimated?: boolean;
}

interface IPointerState {
  visible: boolean;
  isFading: boolean;
}

export class RecommendationsPointer extends React.Component<IPointerProps, IPointerState> {
  public state: IPointerState = {
    visible: false,
    isFading: false,
  };

  public static getDerivedStateFromProps(props: IPointerProps, state: IPointerState) {
    if (!state.visible && props.visible) {
      return { visible: true };
    }

    if (state.visible && !props.visible) {
      return { isFading: true };
    }

    return null;
  }

  public componentDidUpdate(prevProps: IPointerProps, prevState: IPointerState) {
    if (!prevState.isFading && this.state.isFading) {
      setTimeout(() => {
        this.setState({
          visible: false,
          isFading: false,
        });
      }, FADE_MILLISECONDS);
    }
  }

  public render() {
    if (!this.state.visible) {
      return null;
    }

    const { type, isAnimated } = this.props;
    const wrapperStyles = mergeStyles(
      styles['pointer-wrapper'],
      type === 'finger' ? styles['pointer-finger'] : styles['pointer-arrow'],
      isAnimated && styles['pointer-wrapper--animated'],
    );
    const pointerStyles = mergeStyles(styles['pointer'], this.state.isFading && styles['pointer--fade-out']);

    return (
      <span className={styles['pointer-anchor']}>
        <span {...wrapperStyles}>
          <span {...pointerStyles} />
        </span>
      </span>
    );
  }
}
